<div class="container mt-4">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-5">
      <div class="card shadow-sm">
        <div class="card-body p-4">
          <div class="text-center mb-4">
            <h2 class="mb-3">Cancelar Inscrição</h2>
          </div>

          <!-- Mensagem de erro se GUIDs não forem fornecidos -->
          <div class="alert alert-danger" *ngIf="isError && !isSuccess">
            {{ errorMessage }}
          </div>

          <!-- Formulário -->
          <form [formGroup]="unsubscribeForm" (ngSubmit)="onSubmit()" *ngIf="!isSuccess && !isError">
            <div class="mb-3">
              <label class="form-label">Motivo do cancelamento <span class="text-danger">*</span></label>
              <div class="form-check" [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched">
                <input
                  class="form-check-input"
                  type="radio"
                  id="motivo1"
                  formControlName="motivo"
                  value="frequencia"
                  [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched"
                >
                <label class="form-check-label" for="motivo1">
                  Recebo emails com muita frequência
                </label>
              </div>
              <div class="form-check" [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched">
                <input
                  class="form-check-input"
                  type="radio"
                  id="motivo2"
                  formControlName="motivo"
                  value="relevancia"
                  [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched"
                >
                <label class="form-check-label" for="motivo2">
                  O conteúdo não é relevante para mim
                </label>
              </div>
              <div class="form-check" [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched">
                <input
                  class="form-check-input"
                  type="radio"
                  id="motivo3"
                  formControlName="motivo"
                  value="repetitivo"
                  [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched"
                >
                <label class="form-check-label" for="motivo3">
                  O conteúdo é repetitivo
                </label>
              </div>
              <div class="form-check" [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched">
                <input
                  class="form-check-input"
                  type="radio"
                  id="motivo4"
                  formControlName="motivo"
                  value="outro"
                  [class.is-invalid]="unsubscribeForm.get('motivo')?.invalid && unsubscribeForm.get('motivo')?.touched"
                >
                <label class="form-check-label" for="motivo4">
                  Outro motivo
                </label>
              </div>
              <div class="invalid-feedback d-block" *ngIf="unsubscribeForm.get('motivo')?.invalid && (unsubscribeForm.get('motivo')?.touched || unsubscribeForm.get('motivo')?.dirty)">
                Por favor, selecione um motivo para cancelar a inscrição
              </div>
            </div>

            <div class="mb-3" *ngIf="unsubscribeForm.get('motivo')?.value === 'outro'">
              <label for="outroMotivo" class="form-label">Descreva o motivo <span class="text-danger">*</span></label>
              <textarea
                class="form-control"
                id="outroMotivo"
                formControlName="outroMotivo"
                rows="3"
                placeholder="Descreva o motivo do cancelamento..."
                [class.is-invalid]="unsubscribeForm.get('outroMotivo')?.invalid && unsubscribeForm.get('outroMotivo')?.touched"
              ></textarea>
              <div class="invalid-feedback" *ngIf="unsubscribeForm.get('outroMotivo')?.invalid && unsubscribeForm.get('outroMotivo')?.touched">
                Por favor, descreva o motivo
              </div>
            </div>

            <div class="d-grid gap-2">
              <button
                type="submit"
                class="btn btn-danger"
                [disabled]="isLoading || unsubscribeForm.invalid"
              >
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                {{ isLoading ? 'Processando...' : 'Cancelar Inscrição' }}
              </button>
            </div>

            <div class="alert alert-danger mt-3 mb-0" *ngIf="isError">
              {{ errorMessage }}
            </div>
          </form>

          <!-- Mensagem de sucesso -->
          <div *ngIf="isSuccess" class="text-center">
            <div class="mb-3">
              <i class="fas fa-check-circle text-success" style="font-size: 3rem;"></i>
            </div>
            <h4 class="text-success mb-3">Inscrição cancelada com sucesso!</h4>
            <p class="text-muted">
              Você foi removido da nossa lista de emails e não receberá mais nossas comunicações.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

